<div class="content">
  <div class="row mx-0">
    <div class="col-4 px-0 text-start">
      <h3>Internal Consultant Queue</h3>
    </div>
  </div>

  <app-internal-consultant-capture-settings (settingsChange)="onSettingsChange()" />
  @if (!loadingResults) {
    <div class="mt-2">
      @if (captureQueueResults.length > 0) {
        <div>
          <app-capture-queue-results [captureQueueResults]="captureQueueResults" [internalConsultantView]="true" />
          @if (hasMoreResults) {
            <div class="text-center mb-4">
              <a href="#next" (click)="onNextClick($event)" class="load-next-captures">
                View Next {{ limit }} Captures
              </a>
            </div>
          }
        </div>
      } @else {
        <p class="mt-2 ms-1">No captures found. Try modifying the filters.</p>
      }
    </div>
  } @else {
    <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
  }
</div>